import React from 'react';
import { useTranslation } from 'react-i18next';
import { IonButton } from '@ionic/react';

import { AccountSecurityQuestion } from '../../services/types/apitypes';
import QuestionsForm from '../shared/QuestionsForm';

type AccountQuestionsFormProps = {
  isValid: boolean;
  proceed: () => void;
  toQuestions: (position: number) => void;
  securityQuestions: AccountSecurityQuestion[];
  setAnswers: (answer: string, position: number) => void;
};

export default function AccountQuestionsForm({
  isValid,
  proceed,
  toQuestions,
  securityQuestions,
  setAnswers,
}: AccountQuestionsFormProps) {
  const [t] = useTranslation('global');

  return (
    <>
      <h1 className="h1">{t('questions.formtitle')}</h1>
      <p className="pt-2 pb-3 instructions ion-text-center">
        {t('questions.forminfo')}
      </p>

      <QuestionsForm
        toQuestions={toQuestions}
        securityQuestions={securityQuestions}
        setAnswers={setAnswers}
      />

      <div className="pt-3 ion-text-center">
        <IonButton
          className={
            'btn-default btn-wide-80 ' + (isValid ? '' : 'btn-disabled')
          }
          onClick={() => proceed()}
        >
          {t('register.continue')}
        </IonButton>
      </div>
    </>
  );
}
